import { GameMode, PlayerDataMap, WinData } from '@hs-furtwangen/socket-lib'
import { GameModeHelper } from '../Util/GameModeHelper'
import { gameModeIsSondergame, getPointsMultiplier } from '../Util/CalculationHelper'

const getCegoCalculation = (
  gameMode: GameMode,
  winData: WinData,
  lastChallengerId: string,
  tablePlayerIds: string[],
) => {
  let multiplier = 1
  if (gameMode === GameMode.Raeuber) {
    const challengerLost = winData.points[lastChallengerId] < 0
    multiplier = 4
    let jungfrauen: string[] = []

    tablePlayerIds.forEach((id) => {
      if (winData.cardValues[id] === 0) {
        jungfrauen.push(id)
      }
    })
    let baseLoss = 10 * multiplier * 3
    let realLoss = challengerLost ? baseLoss * 2 : baseLoss
    return (
      <>
        <p>
          10 x {multiplier} (Multiplikator {GameModeHelper.gameModeToString(gameMode)}) = <b>{10 * multiplier}</b> x 3
          Spieler = <b>{baseLoss}</b> Punkte Abzug für den Verlierer
        </p>
        {challengerLost && (
          <>
            <br />
            <p>
              Ansager hat verloren. Punkte werden verdoppelt! <b>{baseLoss}</b> x 2 =<b>{` ${realLoss}`}</b> Punkte
              Abzug für den Verlierer
            </p>
          </>
        )}
        {jungfrauen.length === 1 && (
          <>
            <br />
            <p>
              Ein Spieler ist Jungfrau! Der / die Verlierer erhalten zusätzlich <b>120</b> Punkte Abzug!
            </p>
          </>
        )}
        {jungfrauen.length === 2 && (
          <>
            <br />
            <p>
              Zwei Spieler sind Jungfrauen! Der / die Verlierer erhalten zusätzlich <b>240</b> Punkte Abzug!
            </p>
          </>
        )}
      </>
    )
  } else {
    switch (gameMode) {
      case GameMode.Halbe:
      case GameMode.Gegensolo:
        multiplier = 2
        break
      case GameMode.Eine:
        multiplier = 3
        break
      case GameMode.EineLeere:
        multiplier = 4
        break
      case GameMode.ZweiLeere:
        multiplier = 5
        break
      case GameMode.ZweiVerschiedeneLeere:
        multiplier = 6
        break
      case GameMode.KleinerMann:
        multiplier = 7
        break
    }
    if (gameModeIsSondergame(gameMode)) {
      return undefined
    }
    // Nach einem Gegensoli steigen alle Spielwerte um 1 (das Gegensolo selbst zaehlt schon 2)
    const hadGegensoloText = winData.hadGegensolo && gameMode !== GameMode.Gegensolo ? ' + GEGENSOLO' : ''
    multiplier = gameMode !== GameMode.Gegensolo && winData.hadGegensolo ? multiplier + 1 : multiplier
    const challengerPoints = winData.points[lastChallengerId]
    const challengerWon = challengerPoints > 0
    const [, basePoints] = getPointsMultiplier(winData.cardValues[lastChallengerId])
    const modeName = `${GameModeHelper.gameModeToString(gameMode)}${hadGegensoloText}`
    const isBerg = !challengerWon && -challengerPoints === 3 * 40 * multiplier && basePoints !== 40
    if (isBerg) {
      return (
        <>
          Berg: Kein Stich gemacht. <b>40</b> x {multiplier} (Multiplikator {modeName}) = <b>{40 * multiplier}</b> x 3
          Spieler = <b>-{3 * 40 * multiplier} Punkte</b>
        </>
      )
    }
    // Erst multiplizieren, dann auf gerade Zehner aufrunden (Regeln der Schwarzwaldmeisterschaft)
    const rawPoints = basePoints * multiplier
    const roundedPoints = Math.round(rawPoints / 10) * 10
    const needsToBeRounded = rawPoints !== roundedPoints ? ' (gerundet)' : ''
    const soloWinsDouble = gameMode === GameMode.Solo && challengerWon
    return (
      <>
        <b>{basePoints}</b> x {multiplier} (Multiplikator {modeName}) = <b>{roundedPoints}</b>
        {needsToBeRounded} x 3 Spieler = <b>{roundedPoints * 3}</b> Punkte
        {soloWinsDouble && (
          <>
            {' '}
            x 2 (Solo gewinnt doppelt) = <b>{roundedPoints * 3 * 2} Punkte</b>
          </>
        )}
      </>
    )
  }
}

export const getPointsCalculation = (
  winData: WinData,
  gameMode: GameMode,
  lastChallengerId: string,
  tablePlayerIds: string[],
) => {
  try {
    let calculation = null

    calculation = getCegoCalculation(gameMode, winData, lastChallengerId, tablePlayerIds)

    return winData.matchNumber >= 0 ? (
      <>
        <span>{calculation}</span>
      </>
    ) : (
      <></>
    )
  } catch (err) {
    console.log(err)
    return <></>
  }
}

export const getWinnerAnnouncement = (
  winData: WinData,
  gameMode: string,
  lobbyPlayers: PlayerDataMap,
  tablePlayerIds: string[],
) => {
  let winners: string[] = []
  let losers: string[] = []
  let result: [string, number][] = []
  tablePlayerIds.forEach((playerId) => {
    result.push([playerId, winData?.points[playerId]])
  })
  if (winData.matchNumber === -1) {
    // game got cancelled
    return <>Ein Spieler hat den Tisch verlassen, die Partie wurde beendet.</>
  } else if (winData.matchNumber === -2) {
    // game got cancelled
    return <>Das Spiel wurde aufgrund eines Fehlers unerwartet beendet.</>
  }
  result.forEach((info) => {
    if (info[1] > 0) {
      winners.push(lobbyPlayers[info[0]]?.name)
    } else {
      losers.push(lobbyPlayers[info[0]]?.name)
    }
  })
  if (winners?.length === 1) {
    return (
      <>
        {winners[0]} gewinnt <span>{gameMode}</span>
      </>
    )
  } else if (losers?.length === 1) {
    return (
      <>
        {losers[0]} verliert <span>{gameMode}</span>
      </>
    )
  } else if (losers?.length === 2) {
    return (
      <>
        {losers[0]} und {losers[1]} verlieren <span>{gameMode}</span>
      </>
    )
  } else {
    return <></>
  }
}
